import React from "react";
import {ChecklistItemModel} from "../../../../../models/checklist-model";
import styles from "../Checklist.module.scss"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp, faChevronLeft, faChevronRight, faCheck} from "@fortawesome/free-solid-svg-icons";
import ChecklistItem from "./ChecklistItem";
import WorkPackageChecklistItem from "../../WorkPackages/components/WorkPackageChecklistItem";
import {onMessage} from "firebase/messaging";

export default function CheckListItems(props: {
    checkListItemList: ChecklistItemModel[],
    title: string,
}) {
    const {
        checkListItemList,
        title,
    } = props;
    const [showList, setShowList] = React.useState(true);
    const numPages = Math.ceil(checkListItemList.length / 10);
    const [page, setPage] = React.useState(1);
    const [showTaskEventModal, setShowTaskEventModal] = React.useState(false);

  return checkListItemList.length ? (
      <div className={styles.CheckListSection}>
          <div className={styles.ChecklistSectionHeader} style={!showList ? {borderBottom: "1px solid rgba(101, 101, 101, 0.3)"}: {}}>
              <div className={styles.LeftContent} onClick={() => setShowList(!showList)}>
                  <div className={styles.ListIcon}>
                      <FontAwesomeIcon icon={showList ? faChevronUp : faChevronDown}/>
                  </div>
                  <div style={{fontWeight: 'bold'}}>{title}</div>
              </div>
              <div className={styles.RightContent}>
                    <div className={styles.PageCounter}>{page * 10 - 9}-{Math.min(page * 10, checkListItemList.length)} of {checkListItemList.length}</div>
                    <div className={page === 1 ? styles.PageButtonDisabled : styles.PageButton} onClick={() => setPage(Math.max(page - 1, 1))}>
                        <FontAwesomeIcon icon={faChevronLeft}/>
                    </div>
                    <div className={page === numPages ? styles.PageButtonDisabled : styles.PageButton} onClick={() => setPage(Math.min(page + 1, numPages))}>
                        <FontAwesomeIcon icon={faChevronRight}/>
                    </div>
              </div>
          </div>
          {showList && <div className={styles.ChecklistSectionContent}>
              {checkListItemList
                  .slice((page - 1) * 10, Math.min(page * 10, checkListItemList.length))
                  .map((item, index) =>
                      item.type === 'task' ?
                  <ChecklistItem
                      checklistItem={item}
                      title={title}
                      index={index}
                      key={`${title}-${index}`}
                      completionRecord={item.completionRecord}
                  /> : item.workPackage ? <WorkPackageChecklistItem
                          checklistItem={item}
                          title={'title'}
                          index={index}
                          key={`${title}-${index}`}
                          workPackage={item.workPackage} /> : null
              )}
            </div>}
      </div>
  )
      : null
}